import React from 'react';
import { Table, ModalHeader } from 'reactstrap';
import AdvanceStatusBadge from './AdvanceStatusBadge';
import { IAdvanceRequestType } from '../../../types/AdvanceRequestTypes';

interface AdvanceStatusInfoTableProps {
  advanceRequest: IAdvanceRequestType;
}

const AdvanceStatusInfoTable: React.FC<AdvanceStatusInfoTableProps> = ({ advanceRequest }) => {
  const statusReason = advanceRequest.status_reason?.trim() ? advanceRequest.status_reason : '-';

  let riskyReason = '-';
  if (advanceRequest.risky_reasons?.trim()) {
    riskyReason = advanceRequest.risky_reasons;
  } else if (advanceRequest.is_risky) {
    riskyReason = 'Risky';
  }

  return (
    <>
      <ModalHeader className="history-table-header">
        Status Information
      </ModalHeader>
      <Table borderless>
        <thead className="thead-light">
          <tr>
            <th>Current Status</th>
            <th>Status Reason</th>
            <th>Risky Reason</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><AdvanceStatusBadge status={advanceRequest.status} /></td>
            <td>{statusReason}</td>
            <td>{riskyReason}</td>
          </tr>
        </tbody>
      </Table>
    </>
  );
};

export default AdvanceStatusInfoTable;
